import { CommonModule, PercentPipe } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DesignSystemModule } from '@inyova/design-system';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import * as fromComponents from './components';
import * as fromDirectives from './directives';
import * as fromModals from './modals';
import * as fromPipes from './pipes';

@NgModule({
  declarations: [...fromComponents.components, ...fromModals.components, ...fromPipes.pipes, ...fromDirectives.directives],
  exports: [...fromComponents.components, ...fromModals.components, ...fromPipes.pipes, ...fromDirectives.directives, DesignSystemModule],
  imports: [CommonModule, FormsModule, IonicModule, ReactiveFormsModule, TranslateModule, DesignSystemModule],
  providers: [PercentPipe, fromPipes.ThousandSeparatorPipe, provideHttpClient(withInterceptorsFromDi())]
})
export class SharedModule {}
